























import Vue from 'vue'
import { Item2RowLinkElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'Item2RowLinkEl',
  props: {
    templateItemData: {
      type: Object as () => Item2RowLinkElInterface,
      required: true
    }
  }
})
